import React, { Component } from 'react';
import { hideModal, MODAL_FORM_UPDATE_QUIZS } from '../../../../modules/modals';
import { connect } from 'react-redux'
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import FormContent from './FormContent';
import { updateQuizs } from '../../actions';
import moment from 'moment';

class ModalUpdateQuizs extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_FORM_UPDATE_QUIZS});
  }

  getTitle = () => {
    const {formatMessage} = this.context
    let text = "frmTitleUpdateQuizs"
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }

  onSave = async (data) => {
    const {getData, room} = this.props;


    if(data.room == -1){
      data.room = null;
    }

    try {
      await updateQuizs({
        room_id: room.id,
        data: {
          ...data,
          active: data.active ? 1 : 0,
          active_from: moment(data.active_from).unix(),
          active_to: moment(data.active_to).unix(),
        }
      });
      this.handleClose()
      if(getData){
        getData();
      }
    } catch (error) {
      
    }

    
  }

  render() {
    const {formatMessage} = this.context
    const { zIndex } = this.props;
    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content ModalFormQbm"
        >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            <FormContent {...this.props} onSave={this.onSave} handleClose={this.handleClose} />
          </div>
        </Modal>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  hideModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalUpdateQuizs)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Quizs/components/ModalUpdateQuizs/index.jsx